import { connect } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import Table from 'components/table'
import { deleteUsers } from 'app/action-creators'
import Users from 'endpoints/users'

const HEADERS = [
  [35, 'name', (a, b) => a.name.localeCompare(b.name)],
  [30, 'login', (a, b) => a.login.localeCompare(b.login)],
  [25, 'role', (a, b) => a.role.localeCompare(b.role)]
];

const TITLE_BTNS = (
  <Link to="/users/new" className="btn btn-primary">
    <Translate value="users.add_new" />
  </Link>
);

class List extends React.Component {
  constructor() {
    super();
    this.onDelete = this.onDelete.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  onDelete(ids) {
    return Users.del(ids.join(',')).then(() => this.props.deleteUsers(ids));
  }

  editUser(user) {
    this.props.history.push(`/users/${user.id}`);
  }

  renderRow(user, ids, onSelect) {
    let btn, onClick;
    if(ids === null) {
      onClick = this.editUser.bind(this, user);
      btn = (<span className="fa fa-angle-right" />);
    } else if(this.props.currentUser.id !== user.id) {
      btn = (<span className={`fa fa-${ids.includes(user.id) ? 'check-square-o' : 'square-o'}`} />);
      onClick = onSelect;
    }

    return (
      <tr key={user.id} onClick={onClick} className={`table_row ${onClick ? 'table_row--link' : ''}`}>
        <td>{user.name}</td>
        <td>{user.login}</td>
        <td>{user.role}</td>
        <td className="table_row_actions">{btn}</td>
      </tr>
    );
  }

  render() {
    return (
      <Table
        headers={HEADERS}
        list={this.props.users}
        renderRow={this.renderRow}
        title="users.title"
        titleBtns={TITLE_BTNS}
        onDelete={this.onDelete}
      />
    );
  }
}

export default connect(null, { deleteUsers })(List);
